// extracted by mini-css-extract-plugin
export default {"map":"StaticMap-module--map--d1ec8","marker":"StaticMap-module--marker--a06c1"};